import { Checkbox, Empty, Spin, Typography } from 'antd'
import { useEffect, useMemo } from 'react'
import styled from 'styled-components'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import { useSelections } from 'ahooks'
type ColumnsType = {
  flex?: number
  title?: string
  width?: string | number
  render?: (text?: string | number, record?: any) => void
  dataIndex: string
  style?: React.CSSProperties
}
type BackgroundType = {
  [key: string | number]: string | number
}
interface ListProps {
  // children: JSX.Element | JSX.Element[] | string
  background: string | BackgroundType
  backgroundType?: string
  style?: React.CSSProperties
  columns: ColumnsType[]
  loading?: boolean
  dataSource: object[]
  rowKey?: string
}
export const CardListCopy = (props: ListProps) => {
  const { background, style, columns, loading, dataSource, rowKey, backgroundType } = props
  const selectId = useMemo(() => {
    let arr = []
    if (dataSource?.length > 0) {
      arr = dataSource?.map(item => item.id)
    }
    return arr
  }, [dataSource])
  const { selected, allSelected, isSelected, toggle, toggleAll, unSelectAll } =
    useSelections(selectId)
  const RenderItem = (p: { row: any; index: number; dataIndex: string; data: any }) => {
    const { row, index, dataIndex, data } = p
    return (
      <SingleItem key={index} {...row} title={null}>
        {columns[index].render(data[dataIndex], data)}
      </SingleItem>
    )
  }
  return (
    <>
      {loading ? (
        <div
          style={{ display: 'flex', height: 200, alignItems: 'center', justifyContent: 'center' }}
        >
          <Spin />
        </div>
      ) : (
        <>
          {dataSource?.map(item => (
            <TaskList
              background={
                typeof background === 'string' ? background : background[item[backgroundType]]
              }
              style={style}
              key={rowKey ? item[rowKey] : item.id}
            >
              <div className="task-item">
                <div style={{ width: 40, paddingLeft: 1 }}>
                  <Checkbox
                    checked={isSelected(rowKey ? item[rowKey] : item.id)}
                    onChange={() => toggle(rowKey ? item[rowKey] : item.id)}
                  />
                </div>
                {columns?.map(
                  (row, index) =>
                    (row.render && (
                      <RenderItem
                        row={row}
                        key={index}
                        dataIndex={row.dataIndex}
                        index={index}
                        data={item}
                      />
                    )) || (
                      <SingleItem key={index} {...row} title={null} style={row.style}>
                        <Typography.Text ellipsis={{ tooltip: true }} style={{ width: '100%' }}>
                          {item[row.dataIndex]}
                        </Typography.Text>
                      </SingleItem>
                    ),
                )}
              </div>
            </TaskList>
          ))}
          {dataSource?.length === 0 && <Empty image={EmptyImg} />}
        </>
      )}
    </>
  )
}
interface TaskListProps {
  background: string
}
const TaskList = styled.div<TaskListProps>`
  list-style: none;
  height: 80px;
  border-radius: 8px;
  position: relative;
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-end;
  width: calc(100% - 3px);
  .task-item {
    position: relative;
    //z-index: 9;
    width: calc(100% - 3px);
    height: 100%;
    background-color: #f8f9fb;
    border-radius: 8px;
    display: flex;
    padding: 17px;
    align-items: center;
  }
  &::before {
    content: '';
    display: inline-block;
    width: 30px;
    height: 100%;
    background-color: ${props => props.background};
    position: absolute;
    left: 0;
    top: 0;
    //z-index: 1;
    border-radius: 8px;
  }
`
const SingleItem = styled.div<ColumnsType>`
  width: ${props => (props.width ? `${props.width}` : null)};
  flex: ${props => (props.flex ? props.flex : null)};
`
